/**
 * Minified by jsDelivr using Terser v5.17.1.
 * Original file: /npm/@gradio/client@0.1.4/dist/index.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
var fn = new Intl.Collator(0,{
    numeric: 1
}).compare;
function semiver(e, t, a) {
    return e = e.split("."),
    t = t.split("."),
    fn(e[0], t[0]) || fn(e[1], t[1]) || (t[2] = t.slice(2).join("."),
    (a = /[.-]/.test(e[2] = e.slice(2).join("."))) == /[.-]/.test(t[2]) ? fn(e[2], t[2]) : a ? -1 : 1)
}
function determine_protocol(e) {
    if (e.startsWith("http")) {
        const {protocol: t, host: a} = new URL(e);
        return a.endsWith("hf.space") ? {
            ws_protocol: "wss",
            host: a,
            http_protocol: t
        } : {
            ws_protocol: "https:" === t ? "wss" : "ws",
            http_protocol: t,
            host: a
        }
    }
    return {
        ws_protocol: "wss",
        http_protocol: "https:",
        host: e
    }
}
const RE_SPACE_NAME = /^[^\/]*\/[^\/]*$/
  , RE_SPACE_DOMAIN = /.*hf\.space\/{0,1}$/;
async function process_endpoint(e, t) {
    const a = {};
    t && (a.Authorization = `Bearer ${t}`);
    const s = e.trim();
    if (RE_SPACE_NAME.test(s))
        try {
            const t = await fetch(`https://huggingface.co/api/spaces/${s}/host`, {
                headers: a
            });
            if (200 !== t.status)
                throw new Error("Space metadata could not be loaded.");
            return {
                space_id: e,
                ...determine_protocol((await t.json()).host)
            }
        } catch (e) {
            throw new Error("Space metadata could not be loaded." + e.message)
        }
    if (RE_SPACE_DOMAIN.test(s)) {
        const {ws_protocol: e, http_protocol: t, host: a} = determine_protocol(s);
        return {
            space_id: a.replace(".hf.space", ""),
            ws_protocol: e,
            http_protocol: t,
            host: a
        }
    }
    return {
        space_id: !1,
        ...determine_protocol(s)
    }
}
function map_names_to_ids(e) {
    let t = {};
    return e.forEach((({api_name: e},a)=>{
        e && (t[e] = a)
    }
    )),
    t
}
const RE_DISABLED_DISCUSSION = /^(?=[^]*\b[dD]iscussions{0,1}\b)(?=[^]*\b[dD]isabled\b)[^]*$/;
async function discussions_enabled(e) {
    try {
        const t = (await fetch(`https://huggingface.co/api/spaces/${e}/discussions`, {
            method: "HEAD"
        })).headers.get("x-error-message");
        return !t || !RE_DISABLED_DISCUSSION.test(t)
    } catch (e) {
        return !1
    }
}
async function get_space_hardware(e, t) {
    const a = {};
    t && (a.Authorization = `Bearer ${t}`);
    try {
        const t = await fetch(`https://huggingface.co/api/spaces/${e}/runtime`, {
            headers: a
        });
        if (200 !== t.status)
            throw new Error("Space hardware could not be obtained.");
        const {hardware: s} = await t.json();
        return s
    } catch (e) {
        throw new Error(e.message)
    }
}
async function set_space_hardware(e, t, a) {
    const s = {};
    a && (s.Authorization = `Bearer ${a}`);
    try {
        const a = await fetch(`https://huggingface.co/api/spaces/${e}/hardware`, {
            headers: s,
            body: JSON.stringify(t)
        });
        if (200 !== a.status)
            throw new Error("Space hardware could not be set. Please ensure the space hardware provided is valid and that a Hugging Face token is passed in.");
        const {hardware: n} = await a.json();
        return n
    } catch (e) {
        throw new Error(e.message)
    }
}
async function set_space_timeout(e, t, a) {
    const s = {};
    a && (s.Authorization = `Bearer ${a}`);
    try {
        const a = await fetch(`https://huggingface.co/api/spaces/${e}/hardware`, {
            headers: s,
            body: JSON.stringify({
                seconds: t
            })
        });
        if (200 !== a.status)
            throw new Error("Space hardware could not be set. Please ensure the space hardware provided is valid and that a Hugging Face token is passed in.");
        const {hardware: n} = await a.json();
        return n
    } catch (e) {
        throw new Error(e.message)
    }
}
const hardware_types = ["cpu-basic", "cpu-upgrade", "t4-small", "t4-medium", "a10g-small", "a10g-large", "a100-large"]
  , QUEUE_FULL_MSG = "This application is too busy. Keep trying!"
  , BROKEN_CONNECTION_MSG = "Connection errored out.";
let NodeBlob;
async function duplicate(e, t) {
    const {hf_token: a, private: s, hardware: n, timeout: o} = t;
    if (n && !hardware_types.includes(n))
        throw new Error(`Invalid hardware type provided. Valid types are: ${hardware_types.map((e=>`"${e}"`)).join(",")}.`);
    const r = {
        Authorization: `Bearer ${a}`
    }
      , i = (await (await fetch("https://huggingface.co/api/whoami-v2", {
        headers: r
    })).json()).name
      , c = e.split("/")[1]
      , u = {
        repository: `${i}/${c}`
    };
    s && (u.private = !0);
    try {
        const s = await fetch(`https://huggingface.co/api/spaces/${e}/duplicate`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...r
            },
            body: JSON.stringify(u)
        });
        if (409 === s.status)
            return client(`${i}/${c}`, t);
        {
            const r = await s.json();
            let u;
            n || (u = await get_space_hardware(e, a));
            const d = n || u || "cpu-basic";
            return await set_space_hardware(`${i}/${c}`, d, a),
            await set_space_timeout(`${i}/${c}`, o || 300, a),
            client(r.url, t)
        }
    } catch (e) {
        throw new Error(e)
    }
}
function api_factory(e) {
    return {
        post_data: t,
        upload_files: a,
        client: async function(a, n={
            normalise_files: !0
        }) {
            return new Promise((async o=>{
                const {status_callback: r, hf_token: i, normalise_files: c} = n
                  , u = {
                    predict: function(e, t, a) {
                        let s = !1
                          , n = !1;
                        return new Promise(((o,r)=>{
                            const i = E(e, t, a);
                            i.on("data", (e=>{
                                s = !0,
                                n && i.destroy(),
                                o(e)
                            }
                            )).on("status", (e=>{
                                "error" === e.stage && r(e),
                                "complete" === e.stage && s && i.destroy(),
                                "complete" === e.stage && (n = !0)
                            }
                            ))
                        }
                        ))
                    },
                    submit: E,
                    view_api: N
                }
                  , d = c ?? !0;
                if ("undefined" == typeof window || !("WebSocket"in window)) {
                    const e = await import("./wrapper-6f348d45.js");
                    NodeBlob = (await import("buffer")).Blob,
                    global.WebSocket = e.WebSocket
                }
                const {ws_protocol: l, http_protocol: p, host: f, space_id: _} = await process_endpoint(a, i)
                  , h = Math.random().toString(36).substring(2)
                  , g = {};
                let m, w, y = {}, b = !1;
                async function S(e) {
                    m = e,
                    y = map_names_to_ids((null == e ? void 0 : e.dependencies) || []);
                    try {
                        w = await N(m)
                    } catch (e) {
                        console.error(`Could not get api details: ${e.message}`)
                    }
                    return {
                        config: m,
                        ...u
                    }
                }
                i && _ && (b = await get_jwt(_, i));
                try {
                    m = await resolve_config(e, `${p}//${f}`, i);
                    const t = await S(m);
                    o(t)
                } catch (t) {
                    console.error(t),
                    _ ? check_space_status(_, RE_SPACE_NAME.test(_) ? "space_name" : "subdomain", (async function(t) {
                        if (r && r(t),
                        "running" === t.status)
                            try {
                                m = await resolve_config(e, `${p}//${f}`, i);
                                const t = await S(m);
                                o(t)
                            } catch (e) {
                                console.error(e),
                                r && r({
                                    status: "error",
                                    message: "Could not load this space.",
                                    load_status: "error",
                                    detail: "NOT_FOUND"
                                })
                            }
                    }
                    )) : r && r({
                        status: "error",
                        message: "Could not load this space.",
                        load_status: "error",
                        detail: "NOT_FOUND"
                    })
                }
                function E(a, n, o) {
                    let r, c, u;
                    if ("number" == typeof a)
                        r = a,
                        c = w.unnamed_endpoints[r];
                    else {
                        const e = a.replace(/^\//, "");
                        r = y[e],
                        c = w.named_endpoints[a.trim()]
                    }
                    if ("number" != typeof r)
                        throw new Error("There is no endpoint matching that name of fn_index matching that number.");
                    const _ = "number" == typeof a ? "/predict" : a;
                    let S, E = !1;
                    const N = {};
                    function v(e) {
                        const t = N[e.type] || [];
                        null == t || t.forEach((t=>t(e)))
                    }
                    function $(e, t) {
                        const a = N
                          , s = a[e] || [];
                        return a[e] = s,
                        null == s || s.push(t),
                        {
                            on: $,
                            off: O,
                            cancel: B,
                            destroy: D
                        }
                    }
                    function O(e, t) {
                        const a = N;
                        let s = a[e] || [];
                        return s = null == s ? void 0 : s.filter((e=>e !== t)),
                        a[e] = s,
                        {
                            on: $,
                            off: O,
                            cancel: B,
                            destroy: D
                        }
                    }
                    async function B() {
                        const t = {
                            stage: "complete",
                            queue: !1,
                            time: new Date
                        };
                        E = t,
                        v({
                            ...t,
                            type: "status",
                            endpoint: _,
                            fn_index: r
                        }),
                        u && 0 === u.readyState ? u.addEventListener("open", (()=>{
                            u.close()
                        }
                        )) : u.close();
                        try {
                            await e(`${p}//${f + m.path}/reset`, {
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                method: "POST",
                                body: JSON.stringify({
                                    fn_index: r,
                                    session_hash: h
                                })
                            })
                        } catch (e) {
                            console.warn("The `/reset` endpoint could not be called. Subsequent endpoint results may be unreliable.")
                        }
                    }
                    function D() {
                        for (const e in N)
                            N[e].forEach((t=>{
                                O(e, t)
                            }
                            ))
                    }
                    return s(`${p}//${f + m.path}`, n, c, i).then((e=>{
                        if (S = {
                            data: e || [],
                            event_data: o,
                            fn_index: r
                        },
                        skip_queue(r, m))
                            v({
                                type: "status",
                                endpoint: _,
                                stage: "pending",
                                queue: !1,
                                fn_index: r,
                                time: new Date
                            }),
                            t(`${p}//${f + m.path}/run${_.startsWith("/") ? _ : `/${_}`}`, {
                                ...S,
                                session_hash: h
                            }, i).then((([e,t])=>{
                                const a = d ? transform_output(e.data, c, m.root, m.root_url) : e.data;
                                200 == t ? (v({
                                    type: "data",
                                    endpoint: _,
                                    fn_index: r,
                                    data: a,
                                    time: new Date
                                }),
                                v({
                                    type: "status",
                                    endpoint: _,
                                    fn_index: r,
                                    stage: "complete",
                                    eta: e.average_duration,
                                    queue: !1,
                                    time: new Date
                                })) : v({
                                    type: "status",
                                    stage: "error",
                                    endpoint: _,
                                    fn_index: r,
                                    message: e.error,
                                    queue: !1,
                                    time: new Date
                                })
                            }
                            )).catch((e=>{
                                v({
                                    type: "status",
                                    stage: "error",
                                    message: e.message,
                                    endpoint: _,
                                    fn_index: r,
                                    queue: !1,
                                    time: new Date
                                })
                            }
                            ));
                        else {
                            v({
                                type: "status",
                                stage: "pending",
                                queue: !0,
                                endpoint: _,
                                fn_index: r,
                                time: new Date
                            });
                            let e = new URL(`${l}://${f}${m.path}\n\t\t\t\t\t\t\t/queue/join`);
                            b && e.searchParams.set("__sign", b),
                            u = new WebSocket(e),
                            u.onclose = e=>{
                                e.wasClean || v({
                                    type: "status",
                                    stage: "error",
                                    message: BROKEN_CONNECTION_MSG,
                                    queue: !0,
                                    endpoint: _,
                                    fn_index: r,
                                    time: new Date
                                })
                            }
                            ,
                            u.onmessage = function(e) {
                                const t = JSON.parse(e.data)
                                  , {type: a, status: s, data: n} = handle_message(t, g[r]);
                                if ("update" === a && s && !E)
                                    v({
                                        type: "status",
                                        endpoint: _,
                                        fn_index: r,
                                        time: new Date,
                                        ...s
                                    }),
                                    "error" === s.stage && u.close();
                                else {
                                    if ("hash" === a)
                                        return void u.send(JSON.stringify({
                                            fn_index: r,
                                            session_hash: h
                                        }));
                                    "data" === a ? u.send(JSON.stringify({
                                        ...S,
                                        session_hash: h
                                    })) : "complete" === a ? E = s : "generating" === a && v({
                                        type: "status",
                                        time: new Date,
                                        ...s,
                                        stage: null == s ? void 0 : s.stage,
                                        queue: !0,
                                        endpoint: _,
                                        fn_index: r
                                    })
                                }
                                n && (v({
                                    type: "data",
                                    time: new Date,
                                    data: d ? transform_output(n.data, c, m.root, m.root_url) : n.data,
                                    endpoint: _,
                                    fn_index: r
                                }),
                                E && (v({
                                    type: "status",
                                    time: new Date,
                                    ...E,
                                    stage: null == s ? void 0 : s.stage,
                                    queue: !0,
                                    endpoint: _,
                                    fn_index: r
                                }),
                                u.close()))
                            }
                            ,
                            semiver(m.version || "2.0.0", "3.6") < 0 && addEventListener("open", (()=>u.send(JSON.stringify({
                                hash: h
                            }))))
                        }
                    }
                    )),
                    {
                        on: $,
                        off: O,
                        cancel: B,
                        destroy: D
                    }
                }
                async function N(t) {
                    if (w)
                        return w;
                    const a = {
                        "Content-Type": "application/json"
                    };
                    let s;
                    if (i && (a.Authorization = `Bearer ${i}`),
                    s = semiver(t.version || "2.0.0", "3.30") < 0 ? await e("https://gradio-space-api-fetcher-v2.hf.space/api", {
                        method: "POST",
                        body: JSON.stringify({
                            serialize: !1,
                            config: JSON.stringify(t)
                        }),
                        headers: a
                    }) : await e(`${t.root}/info`, {
                        headers: a
                    }),
                    !s.ok)
                        throw new Error(BROKEN_CONNECTION_MSG);
                    let n = await s.json();
                    "api"in n && (n = n.api),
                    n.named_endpoints["/predict"] && !n.unnamed_endpoints[0] && (n.unnamed_endpoints[0] = n.named_endpoints["/predict"]);
                    return transform_api_info(n, t, y)
                }
            }
            ))
        },
        handle_blob: s
    };
    async function t(t, a, s) {
        const n = {
            "Content-Type": "application/json"
        };
        s && (n.Authorization = `Bearer ${s}`);
        try {
            var o = await e(t, {
                method: "POST",
                body: JSON.stringify(a),
                headers: n
            })
        } catch (e) {
            return [{
                error: BROKEN_CONNECTION_MSG
            }, 500]
        }
        return [await o.json(), o.status]
    }
    async function a(t, a, s) {
        const n = {};
        s && (n.Authorization = `Bearer ${s}`);
        const o = new FormData;
        a.forEach((e=>{
            o.append("files", e)
        }
        ));
        try {
            var r = await e(`${t}/upload`, {
                method: "POST",
                body: o,
                headers: n
            })
        } catch (e) {
            return {
                error: BROKEN_CONNECTION_MSG
            }
        }
        return {
            files: await r.json()
        }
    }
    async function s(e, t, s, n) {
        const o = await walk_and_store_blobs(t, void 0, [], !0, s);
        return Promise.all(o.map((async({path: t, blob: s, data: o, type: r})=>{
            if (s) {
                return {
                    path: t,
                    file_url: (await a(e, [s], n)).files[0],
                    type: r
                }
            }
            return {
                path: t,
                base64: o,
                type: r
            }
        }
        ))).then((e=>(e.forEach((({path: e, file_url: a, base64: s, type: n})=>{
            if (s)
                update_object(t, s, e);
            else if ("Gallery" === n)
                update_object(t, a, e);
            else if (a) {
                update_object(t, {
                    is_file: !0,
                    name: `${a}`,
                    data: null
                }, e)
            }
        }
        )),
        t)))
    }
}
const {post_data: post_data, upload_files: upload_files, client: client, handle_blob: handle_blob} = api_factory(fetch);
function transform_output(e, t, a, s) {
    return e.map(((e,n)=>{
        var o, r, i, c;
        return "File" === (null == (r = null == (o = t.returns) ? void 0 : o[n]) ? void 0 : r.component) ? normalise_file(e, a, s) : "Gallery" === (null == (c = null == (i = t.returns) ? void 0 : i[n]) ? void 0 : c.component) ? e.map((e=>Array.isArray(e) ? [normalise_file(e[0], a, s), e[1]] : [normalise_file(e, a, s), null])) : "object" == typeof e && e.is_file ? normalise_file(e, a, s) : e
    }
    ))
}
function normalise_file(e, t, a) {
    if (null == e)
        return null;
    if ("string" == typeof e)
        return {
            name: "file_data",
            data: e
        };
    if (Array.isArray(e)) {
        const s = [];
        for (const n of e)
            null === n ? s.push(null) : s.push(normalise_file(n, t, a));
        return s
    }
    return e.is_file && (e.data = a ? "/proxy=" + a + "file=" + e.name : t + "/file=" + e.name),
    e
}
function get_type(e, t, a, s) {
    switch (e.type) {
    case "string":
        return "string";
    case "boolean":
        return "boolean";
    case "number":
        return "number"
    }
    return "JSONSerializable" === a || "StringSerializable" === a ? "any" : "ListStringSerializable" === a ? "string[]" : "Image" === t ? "parameter" === s ? "Blob | File | Buffer" : "string" : "FileSerializable" === a ? "array" === (null == e ? void 0 : e.type) ? "parameter" === s ? "(Blob | File | Buffer)[]" : "{ name: string; data: string; size?: number; is_file?: boolean; orig_name?: string}[]" : "parameter" === s ? "Blob | File | Buffer" : "{ name: string; data: string; size?: number; is_file?: boolean; orig_name?: string}" : "GallerySerializable" === a ? "parameter" === s ? "[(Blob | File | Buffer), (string | null)][]" : "[{ name: string; data: string; size?: number; is_file?: boolean; orig_name?: string}, (string | null))][]" : void 0
}
function get_description(e, t) {
    return "GallerySerializable" === t ? "array of [file, label] tuples" : "ListStringSerializable" === t ? "array of strings" : "FileSerializable" === t ? "array of files or single file" : e.description
}
function transform_api_info(e, t, a) {
    const s = {
        named_endpoints: {},
        unnamed_endpoints: {}
    };
    for (const n in e) {
        const o = e[n];
        for (const e in o) {
            const r = t.dependencies[e] ? e : a[e.replace("/", "")]
              , i = o[e];
            s[n][e] = {},
            s[n][e].parameters = {},
            s[n][e].returns = {},
            s[n][e].type = t.dependencies[r].types,
            s[n][e].parameters = i.parameters.map((({label: e, component: t, type: a, serializer: s})=>({
                label: e,
                component: t,
                type: get_type(a, t, s, "parameter"),
                description: get_description(a, s)
            }))),
            s[n][e].returns = i.returns.map((({label: e, component: t, type: a, serializer: s})=>({
                label: e,
                component: t,
                type: get_type(a, t, s, "return"),
                description: get_description(a, s)
            })))
        }
    }
    return s
}
async function get_jwt(e, t) {
    try {
        const a = await fetch(`https://huggingface.co/api/spaces/${e}/jwt`, {
            headers: {
                Authorization: `Bearer ${t}`
            }
        });
        return (await a.json()).token || !1
    } catch (e) {
        return console.error(e),
        !1
    }
}
function update_object(e, t, a) {
    for (; a.length > 1; )
        e = e[a.shift()];
    e[a.shift()] = t
}
async function walk_and_store_blobs(e, t=void 0, a=[], s=!1, n=void 0) {
    if (Array.isArray(e)) {
        let o = [];
        return await Promise.all(e.map((async(r,i)=>{
            var c;
            let u = a.slice();
            u.push(i);
            const d = await walk_and_store_blobs(e[i], s ? (null == (c = null == n ? void 0 : n.parameters[i]) ? void 0 : c.component) || void 0 : t, u, !1, n);
            o = o.concat(d)
        }
        ))),
        o
    }
    if (globalThis.Buffer && e instanceof globalThis.Buffer) {
        const s = "Image" === t;
        return [{
            path: a,
            blob: !s && new NodeBlob([e]),
            data: !!s && `${e.toString("base64")}`,
            type: t
        }]
    }
    if (e instanceof Blob || "undefined" != typeof window && e instanceof File) {
        if ("Image" === t) {
            let s;
            if ("undefined" != typeof window)
                s = await image_to_data_uri(e);
            else {
                const t = await e.arrayBuffer();
                s = Buffer.from(t).toString("base64")
            }
            return [{
                path: a,
                data: s,
                type: t
            }]
        }
        return [{
            path: a,
            blob: e,
            type: t
        }]
    }
    if ("object" == typeof e) {
        let t = [];
        for (let s in e)
            if (e.hasOwnProperty(s)) {
                let o = a.slice();
                o.push(s),
                t = t.concat(await walk_and_store_blobs(e[s], void 0, o, !1, n))
            }
        return t
    }
    return []
}
function image_to_data_uri(e) {
    return new Promise(((t,a)=>{
        const s = new FileReader;
        s.onloadend = ()=>t(s.result),
        s.readAsDataURL(e)
    }
    ))
}
function skip_queue(e, t) {
    var a, s, n, o;
    return !(null === (null == (s = null == (a = null == t ? void 0 : t.dependencies) ? void 0 : a[e]) ? void 0 : s.queue) ? t.enable_queue : null == (o = null == (n = null == t ? void 0 : t.dependencies) ? void 0 : n[e]) ? void 0 : o.queue) || !1
}
async function resolve_config(e, t, a) {
    const s = {};
    if (a && (s.Authorization = `Bearer ${a}`),
    "undefined" != typeof window && window.gradio_config && "http://localhost:9876" !== location.origin) {
        const e = window.gradio_config.root
          , a = window.gradio_config;
        return a.root = t + a.root,
        {
            ...a,
            path: e
        }
    }
    if (t) {
        let a = await e(`${t}/config`, {
            headers: s
        });
        if (200 === a.status) {
            const e = await a.json();
            return e.path = e.path ?? "",
            e.root = t,
            e
        }
        throw new Error("Could not get config.")
    }
    throw new Error("No config or app endpoint found")
}
async function check_space_status(e, t, a) {
    let s, n, o = "subdomain" === t ? `https://huggingface.co/api/spaces/by-subdomain/${e}` : `https://huggingface.co/api/spaces/${e}`;
    try {
        if (s = await fetch(o),
        n = s.status,
        200 !== n)
            throw new Error;
        s = await s.json()
    } catch (e) {
        return void a({
            status: "error",
            load_status: "error",
            message: "Could not get space status",
            detail: "NOT_FOUND"
        })
    }
    if (!s || 200 !== n)
        return;
    const {runtime: {stage: r}, id: i} = s;
    switch (r) {
    case "STOPPED":
    case "SLEEPING":
        a({
            status: "sleeping",
            load_status: "pending",
            message: "Space is asleep. Waking it up...",
            detail: r
        }),
        setTimeout((()=>{
            check_space_status(e, t, a)
        }
        ), 1e3);
        break;
    case "PAUSED":
        a({
            status: "paused",
            load_status: "error",
            message: "This space has been paused by the author. If you would like to try this demo, consider duplicating the space.",
            detail: r,
            discussions_enabled: await discussions_enabled(i)
        });
        break;
    case "RUNNING":
    case "RUNNING_BUILDING":
        a({
            status: "running",
            load_status: "complete",
            message: "",
            detail: r
        });
        break;
    case "BUILDING":
        a({
            status: "building",
            load_status: "pending",
            message: "Space is building...",
            detail: r
        }),
        setTimeout((()=>{
            check_space_status(e, t, a)
        }
        ), 1e3);
        break;
    default:
        a({
            status: "space_error",
            load_status: "error",
            message: "This space is experiencing an issue.",
            detail: r,
            discussions_enabled: await discussions_enabled(i)
        })
    }
}
function handle_message(e, t) {
    const a = !0;
    switch (e.msg) {
    case "send_data":
        return {
            type: "data"
        };
    case "send_hash":
        return {
            type: "hash"
        };
    case "queue_full":
        return {
            type: "update",
            status: {
                queue: a,
                message: QUEUE_FULL_MSG,
                stage: "error",
                code: e.code,
                success: e.success
            }
        };
    case "estimation":
        return {
            type: "update",
            status: {
                queue: a,
                stage: t || "pending",
                code: e.code,
                size: e.queue_size,
                position: e.rank,
                eta: e.rank_eta,
                success: e.success
            }
        };
    case "progress":
        return {
            type: "update",
            status: {
                queue: a,
                stage: "pending",
                code: e.code,
                progress_data: e.progress_data,
                success: e.success
            }
        };
    case "process_generating":
        return {
            type: "generating",
            status: {
                queue: a,
                message: e.success ? null : e.output.error,
                stage: e.success ? "generating" : "error",
                code: e.code,
                progress_data: e.progress_data,
                eta: e.average_duration
            },
            data: e.success ? e.output : null
        };
    case "process_completed":
        return "error"in e.output ? {
            type: "update",
            status: {
                queue: a,
                message: e.output.error,
                stage: "error",
                code: e.code,
                success: e.success
            }
        } : {
            type: "complete",
            status: {
                queue: a,
                message: e.success ? void 0 : e.output.error,
                stage: e.success ? "complete" : "error",
                code: e.code,
                progress_data: e.progress_data,
                eta: e.output.average_duration
            },
            data: e.success ? e.output : null
        };
    case "process_starts":
        return {
            type: "update",
            status: {
                queue: a,
                stage: "pending",
                code: e.code,
                size: e.rank,
                position: 0,
                success: e.success
            }
        }
    }
    return {
        type: "none",
        status: {
            stage: "error",
            queue: a
        }
    }
}
export {api_factory, client, duplicate, post_data, upload_files};
//# sourceMappingURL=/sm/018f6a021da8140fa1eb9e20769f7ebd096fe7f43b62bf7e78935dd18ef7d4e6.map
